import { concat, map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type VaccinationStatusSelectInput_query$key } from '@/__generated__/VaccinationStatusSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SingleSelectInputProps,
  type SingleSelectInputRef,
  type SingleSelectOption
} from '@/components'

export type VaccinationStatusSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: VaccinationStatusSelectInput_query$key | null | undefined
}

export const VaccinationStatusSelectInput = forwardRef<SingleSelectInputRef, VaccinationStatusSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment VaccinationStatusSelectInput_query on Query {
          vaccinationStatuses(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SingleSelectOption[]>(
          () =>
            concat(
              map(queryData?.vaccinationStatuses?.nodes, (vaccinationStatus) => ({
                label: vaccinationStatus!.name,
                value: vaccinationStatus!.rowId
              })),
              [{ label: 'Don’t Show This', value: null }]
            ),
          [queryData?.vaccinationStatuses?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

VaccinationStatusSelectInput.displayName = 'VaccinationStatusSelectInput'
